export const MY_REWARDS_URL = '/my-rewards';